import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { PrvNextButtonsComponent } from "../../components/prv-next-buttons/prv-next-buttons.component";
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { EopAssistantComponent } from '../../components/eop-assistant/eop-assistant.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SendAssessmentComponent } from './send-assessment/send-assessment.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PopupMessageComponent } from '../../components/popup-message/popup-message.component';
import { UserDataService } from '../../../shared/services/userData.service';
import { AssessmentService } from '../../../shared/services/assessment.service';
import { IAssessment } from '../../../shared/models/assessment';
import { IntroductionComponent } from '../../components/introduction/introduction.component';
import { AssessDetailsComponent } from './assess-details/assess-details.component';
import { DeleteConfirmationComponent } from "../../components/delete-confirmation/delete-confirmation.component";
import { EopNavigationService } from '../../../shared/services/eopNavigation.service';
import { environment } from '../../../environments/environments';
import { DateUtils } from '../../../shared/helpers/dateUtils';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ESectionTypes } from '../../../shared/models/eop_types.enum';
import { IUserInfo } from '../../../shared/models/contact';
import { NoEmojiDirective } from '../../../shared/helpers/noEmoji.directive';
declare var initFlowbite: any;

@Component({
  selector: 'app-assessments',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    EopAssistantComponent,
    PrvNextButtonsComponent,
    SpinnerComponent,
    SendAssessmentComponent,
    PopupMessageComponent,
    IntroductionComponent,
    AssessDetailsComponent,
    LucideAngularModule,
    NoEmojiDirective, 
    DeleteConfirmationComponent,
    NgxPaginationModule
],
  templateUrl: './assessments.component.html',
  styleUrl: './assessments.component.css'
})
export class AssessmentsComponent implements OnInit, OnDestroy {

  icons = Icons;
  sectionType = ESectionTypes['Assessments'];
  searchQuery: string = '';
  currentBuildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  hasnSideAssess: string | null = null;
  selectedAssessType: string | null = null;
  fullAssessmentsList: IAssessment[] = [];
  assessmentsList: IAssessment[] = [];
  selectedAssess: IAssessment | null = null;
  assessToDelete: number | null = null;
  messageModal: string | null = null;
  popupMessage: string = '';
  schoolYears: string[] = [];
  selectedSchoolYear: string = '';
  page = 1;
  itemsPerPage = 10;

  loading: boolean = false;
  sortOrder: boolean = true;
  showSendAssess: boolean = false;
  showAssessDetails: boolean = false;
  showDeleteConfirmation: boolean = false;
  isSchoolYearDropdownOpen = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userDataService: UserDataService,
    private assessmentService: AssessmentService,
    public eopNavigationService: EopNavigationService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getUserData();
    this.hasnSideAssess = this.userDataService.getHasAssess();
    document.addEventListener('click', this.handleClickOutside);
    this.schoolYears = DateUtils.getSchoolYears(6);
    this.selectedSchoolYear = DateUtils.getCurrentSchoolYear();

    if (isPlatformBrowser(this.platformId)) {
      initFlowbite();
    }
    this.loadAssessments();
  }
  
  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('#schoolYearDropdownButton') && !target.closest('#schoolYearDropdown')) {
      this.isSchoolYearDropdownOpen = false;
    }
  };
  
  toggleSchoolYearDropdown(): void {
    this.isSchoolYearDropdownOpen = !this.isSchoolYearDropdownOpen;
  }

  handleSchoolYearSelect(year: string): void {
    this.selectedSchoolYear = year;
    this.isSchoolYearDropdownOpen = false;
    this.loadAssessments();
  }

  loadAssessments(): void {
    if (this.currentBuildingId) {
      this.loading = true;
      this.assessmentService.getAssessments(this.currentBuildingId, this.selectedSchoolYear).subscribe({
        next: (response) => {
          this.loading = false;
          console.log('Assessments loaded:', response);
          if (!response.has_error) {
            this.fullAssessmentsList = response.data ? response.data : [];
            this.assessmentsList = [...this.fullAssessmentsList].reverse(); // Reverse the list to show the most recent assessments first
            console.table(this.assessmentsList);
            setTimeout(() => {
              if (isPlatformBrowser(this.platformId)) {
                initFlowbite();
              }
            }, 50);
          }
        },
        error: (error: any) => {
          this.loading = false;
          console.error('Error loading contacts:', error.message);
        }
      });
    }
  };

  handleOpenModal(modalName: string, selectedItem?: any): void {
    if (modalName === 'send-assess') {
      this.showSendAssess = true;
      this.selectedAssessType = selectedItem
    } else if (modalName === 'assess-details') {
      this.showAssessDetails = true;
      this.selectedAssess = selectedItem
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = true;
    }
  }

  handleCloseModal(modalName: string): void {
    if (modalName === 'send-assess') {
      this.showSendAssess = false;
      this.selectedAssessType = null;
    } else if (modalName === 'assess-details') {
      this.showAssessDetails = false;
    }else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = false;
    }
    this.selectedAssess = null;
  }

  handleSave(message: {type: string, message: string}, actionType: string): void {
    this.handleCloseModal(actionType);
    this.loadAssessments(); 
    
    if (message.type === 'success') {
      this.messageModal = 'success';
      this.popupMessage = message.message;
      
    } else if (message.type === 'unsuccess') {
      this.messageModal = 'unsuccess';
      this.popupMessage = message.message;
    } 
  }

  goToThreatAssess(): void {
    window.open(`${environment.nSideAssessUrl}`, '_blank');
  }

  handleDelete(item: any): void {
    this.loading = true;
    this.showDeleteConfirmation = false;
    console.log(item.id);
    this.assessmentService.deleteAssess(String(item.id)).subscribe({
      next: (response) => {
        this.selectedAssess = null;
        this.loading = false;
        this.messageModal = "success";
        this.popupMessage = 'This occurred after deleting an assessment.';
        this.loadAssessments();
      },
      error: (error: any) => {
        this.selectedAssess = null;
        this.loading = false;
        this.messageModal = "unsuccess";
        this.popupMessage = error.message;
        console.error('Error deleting assess:', error.message);
      }
    })
  }

  sortList(key: keyof typeof this.assessmentsList[0]): void {
    this.sortOrder = !this.sortOrder;
    this.assessmentsList.sort((a, b) => {
      const valueA = a[key]?.toString().toLowerCase() || '';
      const valueB = b[key]?.toString().toLowerCase() || '';

      if (valueA < valueB) {
        return this.sortOrder ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortOrder ? 1 : -1;
      }
      return 0;
    });
  }  

  filterSchedulesList(): void {
    const query = this.searchQuery.toLowerCase().trim();
  
    this.assessmentsList = this.fullAssessmentsList.filter((item) => {
      return (
        item.type_name?.toLowerCase().includes(query) ||
        item.sub_type_name?.toLowerCase().includes(query) ||
        item.date_sent?.toLowerCase().includes(query) ||
        item.user_name_sent?.toLowerCase().includes(query)
      );
    });
  }

  downloadSurvey(guid: string): void {
    if (guid) {
      this.loading = true;
      this.assessmentService.downloadSurvey(guid).subscribe({
        next: (response: Blob) => {
          this.loading = false;
          const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `assessment_${guid}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: (error: any) => {
          this.loading = false;
          console.error('Error downloading survey:', error.message);
        }
      });
    }
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  resetMessageModal(): void {
    this.messageModal = null;
  }

}
